import React, { Component } from 'react';
import classess from './loginMFAContainer.scss';
import MfaModal from '../Modal/MfaModal.js';
import LoadIndicator from '../../../../Common/CommonComponents/LoadingIndicator/loadingIndicator';
import CustomAnchorTag from '../../../../Common/CommonComponents/CustomAnchorTag/customAnchorTag.js';
import SuccessMessage from '../TurnOnMFA/SuccessMessage/SuccessMessage.js';
import { getLocalizedStrings } from  '../mfaPageLocalizedStrings';
import classes from  '../../../CPCGuest/GuestBPSearch/guestBPSearch.scss';
import TimeOut from '../TimeOut/TimeOut.js';

class LoginMFAContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentScreen: 'send-code',
      receiveCodeVia: 'text',
      userLoginInfoDetails: {},
      verificationCode: '',
      showLoader: false,
      showError: false,
      verifyErrMsg: '',
      isTimeout:false
    };
    this.strings = getLocalizedStrings('LoginMFA');
    this.timeoutId = null;
  }
  componentDidMount() {
    const userLoginInfoDetails = JSON.parse(app.appService.getLocalStorage('mfaInfo'));
    this.setState({ userLoginInfoDetails });
    if(!app.appService.isAuthenticated()){
      this.timeoutId = setTimeout(()=>{
        this.setState({isTimeout:true});
      }, 260*1000);
    } // remove timer code and timeout import for phase 2 becuase login flow will be handled by widget
  }

  componentWillUnmount(){
    if(this.timeoutId){
      clearTimeout(this.timeoutId);
    }
  }
    handleSendCode = async (codeViaEmail) => {
      const { userLoginInfoDetails = {}, receiveCodeVia, sendCodeResponseObj = {} } = this.state;
      const { phoneNumber, emailId, oktaUid } = userLoginInfoDetails;
      try {
        const reqObj = {
          type: codeViaEmail || receiveCodeVia,
          oktaId: oktaUid,
          encValue: phoneNumber,
          value: emailId,
          txnName:'login'
        };
        const preLoginEncryptPhone = app.appService.getSessionstorage('preLoginPhone') || [];
        if(app.appService.isAuthenticated() && preLoginEncryptPhone.includes(reqObj.encValue)){
          reqObj['txnName'] = 'mfa';
        }
        this.setState({ showLoader: true, showError: false });
        const res = await app.centralizedService.twoFactorAuthSendCode(reqObj, sendCodeResponseObj);
        if (res.sendPinstatus === 'Failure') {
          if (res.oktaUpdateStatus.errorCode === 'OKTA_E0000109' || res.oktaUpdateStatus.errorCode === 'OKTA_E0000133' || res.oktaUpdateStatus.errorCode === 'E0000150' || res.oktaUpdateStatus.errorCode === 'E0000151') {
            throw {errorMsg: this.strings.sendCodeWaitError, response:res};
          }
          throw {errorMsg: this.strings.sendCodeGeneralError, response:res};
        }
        this.setState({
          sendCodeResponseObj: res,
          currentScreen: 'verify',
          showLoader: false,
          showError: false,
          verificationCode: ''
        });
      } catch (error) {
  
        this.setState({ showLoader: false, showError: true, currentScreen: 'verify', sendCodeResponseObj: error.response || {}, verifyErrMsg: error.errorMsg || this.strings.sendCodeGeneralError});
      }

    };
    handleVerifyCode = async () => {
      // make a call to verification endpoint
      const { fromProfile, isAddingNewNumber, newNumber } = this.props;
      const {
        userLoginInfoDetails = {},
        receiveCodeVia,
        sendCodeResponseObj = {},
        verificationCode,
      } = this.state;
      const { phoneNumber, emailId, oktaUid } = userLoginInfoDetails;
      if(verificationCode === ''){
        this.setState({ showError: true, verifyErrMsg: 'Please enter a valid verification code' });
        return;
      }

      try {
        this.setState({ showLoader: true });
        const oktaExpireAt = app.appService.getSessionstorage('oktaExpireAt') || '';
        const twoFactorAuthValues = {
          type: receiveCodeVia,
          oktaId: oktaUid,
          oktaExpireAt,
          encValue: phoneNumber,
          value: emailId
        };
        let newMfaAttributes = null;
        let encryptedPhone = null;

        if (fromProfile) {
          if (isAddingNewNumber) {
            const languagePrefRes = app.appService.getSessionstorage('customerPreferenceData') || {};

            twoFactorAuthValues['mainBpNumber'] = languagePrefRes.businessPartnerNumber;

            const reqObj = { phoneNo: newNumber };
            const baRes = await app.myAccountService.baPhoneEncryption(reqObj); 
            encryptedPhone = baRes.phoneNumber;
            if(!app.appService.isAuthenticated()){
              const preLoginEncryptPhoneProfile = app.appService.getSessionstorage('preLoginPhone') || [];
              preLoginEncryptPhoneProfile.push(encryptedPhone);
              app.appService.setSessionstorage('preLoginPhone', preLoginEncryptPhoneProfile);
            }
            newMfaAttributes = {
              oktaUpdate: 1,
              addUpdate: {
                profileUpdate: [
                  {
                    'elementName': 'primaryPhone',
                    'elementValue': encryptedPhone
                  },
                  {
                    'elementName': 'eixSCEMFAStatus',
                    'elementValue': 'Enrolled'
                  },
                ],
                phoneNumbers: [{
                  'standardIndicatorPhoneNumber': '',
                  'telephoneNumber': encryptedPhone,
                  'changeFlag': 'I',
                  'telephoneExtension': '',
                  'indicatorSmsEnabled': '',
                  'indicatorTelephone': '3',
                  'flagNotUsed': '',
                  'sequenceNumber': ''
                }]
              }
            };
          } else {
            
            newMfaAttributes = {
              oktaUpdate: 1,
              addUpdate: {
                profileUpdate: [
                  {
                    'elementName': 'eixSCEMFAStatus',
                    'elementValue': 'De-Enrolled'
                  },
                ]
              }
            };
          }
        }
        const preLoginEncryptPhone = app.appService.getSessionstorage('preLoginPhone') || [];
        if (app.appService.isAuthenticated() && preLoginEncryptPhone.includes(twoFactorAuthValues.encValue)) twoFactorAuthValues['txnName'] = 'mfa';
          
        
        const res = await app.centralizedService.verifyPin(twoFactorAuthValues, verificationCode, 'Mobile', sendCodeResponseObj, newMfaAttributes, true);
        if (res.factorstatus === 'Success') {
          if (fromProfile) {
            if (isAddingNewNumber) {
              app.appService.setLocalStorage('mfaInfo',
                {
                  ...userLoginInfoDetails,
                  maskedValue: newNumber,
                  phoneNumber: encryptedPhone
                });
            } else {
              app.appService.setLocalStorage('mfaInfo', { ...userLoginInfoDetails, eixSCEMFAStatus: 'NeverAsk' });
            }

            this.setState({ currentScreen: 'success', showLoader: false, showError: false });
          } else {
            if (window.location.pathname === '/residential/rates/rate-plan-comparison-tool') {
              app.appService.setLocalStorage('userpath', app.appUtil.getAppRoutes().RATEANALYZER.RATE_LOADING_RESIDENTIAL);
              app.appService.setLocalStorage('isPortalUserAuthenticated', true);
              app.appService.setSessionstorage('RateAnalyzerLoggedInStatus', true);
            }
            app.appService.setSessionstorage('oktaSessionToken', res.oktaSessionToken);
            let userLogin = app.appService.getSessionstorage('userLogin');
            userLogin.oktaSessionToken = res.oktaSessionToken;
            app.appService.setSessionstorage('userLogin', userLogin);
            const { isSpocUser } = app.appService.getSessionstorage('nonMigratedData') || {};
            if (isSpocUser) {
              app.appUtil.navigateToFromLogin(app.appUtil.getAppRoutes().LOGIN.CHANGE_PASSWORD);
              return;
            }
            app.appService.removeSessionStorageItem(app.appService.appConstants.isPwdChanged);
            app.identityService.activate();
          }

        } else {
          throw new Error('Verification failed');
        }
      } catch (error) {
        this.setState({ showLoader: false, showError: true, verifyErrMsg: this.strings.verifyError });
      }

    };


    handleViaEmail = () => {
      this.handleSendCode('email');
      this.setState({ currentScreen: 'verify', receiveCodeVia: 'email' });
    };

    onEnterKeyPress = (event,func) => {
      if(event.key === 'Enter'){
        func();
      }
    };

    handleGoToAccount = () => {
      // redirect to account page
      const { onClose = (() => { /* This is intentional */ }), fromProfile } = this.props;
      if (fromProfile) {
        onClose();
        app.appUtil.navigateTo(app.appUtil.getAppRoutes().SELFSERVICESFORMS.PROFILE_PAGE);
        return;
      }
    };
    handleCancel = () => {
      const { onClose, onReopenParentPopup } = this.props;
      onClose();
      if (onReopenParentPopup) {
        onReopenParentPopup();
      }
    };

  handleDifferentMethod = () => {
    this.setState({ currentScreen: 'send-code', receiveCodeVia: 'text', sendCodeResponseObj: {}, showError: false });
  }

    render() {
      const {
        fromProfile,
        isAddingNewNumber,
        newNumber = ''
      } = this.props;
      const { currentScreen, receiveCodeVia, showLoader, showError, verifyErrMsg, userLoginInfoDetails = {}, verificationCode = '', isTimeout} = this.state;
      const { emailId = '', maskedValue = '' } = userLoginInfoDetails;
      const maskedEmailId = emailId ? emailId.split('@')[0].slice(0, 2) + '****' + emailId.split('@')[0].slice(-3) + '@' + emailId.split('@')[1] : '';

      if(isTimeout){
        return <TimeOut />;
      }

      return (<MfaModal isOpen>
        {showLoader ? <LoadIndicator showLoading={showLoader} /> : <div>
          {currentScreen === 'send-code' && (
            <div>
              <div className={classess.mfaHeading}>{this.strings.heading}</div>
              <p>{this.strings.content} {maskedValue && maskedValue.slice(-4)}?</p>
              <div>
                <label>
                  <input type='radio' value='text' className={classess.radioButton} checked={receiveCodeVia === 'text'} onChange={() => this.setState({ receiveCodeVia: 'text' })}
                  />
                                {this.strings.textMe}
                </label>
              </div>
              <div>
                <label>
                  <input type='radio' value='call' className={classess.radioButton} checked={receiveCodeVia === 'call'} onChange={() => this.setState({ receiveCodeVia: 'call' })} />
                                {this.strings.callMe}
                </label>
              </div>
              {!fromProfile && <div>
                <p>{this.strings.phoneQuestion}</p>
                <p onClick={this.handleViaEmail} onKeyDown={(event) => this.onEnterKeyPress(event,this.handleViaEmail)} tabIndex={0} className={`${classess.linkColorCursor} ${classess.textUnderline}`}>{this.strings.emailOTP} </p>
              </div>}
              <div className={classess.modalActions}>
                <button className={classess.mfaCodeSend} onClick={() => this.handleSendCode()}>{this.strings.sendCode}</button>
                <button className={classess.mfaCancel} onClick={this.handleCancel}>{this.strings.cancel}</button>
              </div>
            </div>
          )}
          {currentScreen === 'verify' && (
            <div>
              {(receiveCodeVia === 'text' || receiveCodeVia === 'call') && <h3 className={classess.mfaHeading}>{this.strings.verifyPhoneHeading} {maskedValue && maskedValue.slice(-4)}</h3>}
              {receiveCodeVia === 'email' && <h3 className={classess.mfaHeading}>{this.strings.verifyEmailHeading} {maskedEmailId}</h3>}
              <div className={classess.modalActions}>
                <label><p className={classess.enterCodeLabel}>{this.strings.enterCode}</p>
                  <input
                    type='text'
                    placeholder='Enter Code'
                    className={classess.mfaPhoneNumber}
                    value={verificationCode}
                    maxLength={6}
                    onChange={(e) => {
                      const value = e.target.value !== '' ? e.target.value.match(/\d+/g).join('') : '';
                      this.setState({ verificationCode: value, showError: false });
                    }}
                  />
                </label>
                <button className={classess.mfaCodeSend} onClick={this.handleVerifyCode} >{this.strings.verify}</button>
                <button className={classess.mfaCancel} onClick={this.handleCancel}>{this.strings.cancel}</button>
                {showError === true && <div className={classes.searchError + ' ' + classess.mfaError} >{verifyErrMsg}</div>}
              </div>

              <p>{this.strings.anotherCode}</p>

              <p>
                <CustomAnchorTag linkName={<span onClick={() => this.handleSendCode()} onKeyDown={(event) => this.onEnterKeyPress(event, this.handleSendCode)} tabIndex={0} className={`${classess.linkColorCursor} ${classess.textUnderline}`}>{this.strings.resend} </span>} />
              </p>
              <CustomAnchorTag linkName={<span onClick={this.handleDifferentMethod} onKeyDown={(event) => this.onEnterKeyPress(event, this.handleDifferentMethod)} tabIndex={0} className={`${classess.linkColorCursor} ${classess.textUnderline}`} >{this.strings.differentMethod}</span>} />
              
            </div>
          )}
          {currentScreen === 'success' && fromProfile && (
            <SuccessMessage handleGoToAccount={this.handleGoToAccount} fromProfile={fromProfile} isAddingNewNumber={isAddingNewNumber} newNumber={newNumber.slice(0, -4).replace(/\d/g, 'X') + newNumber.slice(-4)} onEnterKeyPress={this.onEnterKeyPress}
            />
          )}
        </div>
        }
      </MfaModal>);
    }
}

export default LoginMFAContainer;
